import moment from 'moment'
import * as R from 'ramda'

const formatComparisonParams = (values, fieldName) => {
  let params = {}
  params[`${fieldName}.${values.comparison_one.value}`] = values.threshold_one
  if (values.threshold_two) {
    params[`${fieldName}.${values.comparison_two.value}`] = values.threshold_two
  }
  return params
}

const formatDateParams = (values, dateType) => {
  const params = formatComparisonParams({
    comparison_one: {
      value: values.comparison_one.value
    },
    threshold_one: moment(values.threshold_one).format('YYYY-MM-DD'),
    comparison_two: {
      value: values.comparison_two.value
    },
    threshold_two: moment(values.threshold_two).format('YYYY-MM-DD')
  }, dateType)

  if (values.timezone) {
    params[`${dateType}.tz`] = values.timezone
  }
  return params
}

const FormatterMap = {
  category: values => {
    return {
      category: values.categories.join(',')
    }
  },
  country: values => {
    return {
      country: values.countries.map(country => country.code).join(',')
    }
  },
  label: values => {
    return {
      label: values.labels.join(',')
    }
  },
  place: values => {
    const params = {}
    params[`place.${values.type}`] = values.places.map(place => place.value).join(',')
    return params
  },
  rank: values => {
    return {
      rank_level: values.ranks.map(rank => rank.value).join(',')
    }
  },
  'rank-range': values => {
    return formatComparisonParams(values, 'rank')
  },
  'local-rank': values => {
    return {
      local_rank_level: values.local_ranks.map(rank => rank.value).join(',')
    }
  },
  'local-rank-range': values => {
    return formatComparisonParams(values, 'local_rank')
  },
  'aviation-rank': values => {
    return {
      aviation_rank_level: values.aviation_ranks.map(rank => rank.value).join(',')
    }
  },
  'aviation-rank-range': values => {
    return formatComparisonParams(values, 'aviation_rank')
  },
  'phq-attendance': values => {
    return formatComparisonParams(values, 'phq_attendance')
  },
  state: values => {
    return {
      state: values.states.join(',')
    }
  },
  start: values => {
    return formatDateParams(values, 'start')
  },
  end: values => {
    return formatDateParams(values, 'end')
  },
  active: values => {
    return formatDateParams(values, 'active')
  },
  updated: values => {
    return formatDateParams(values, 'updated')
  },
  within: values => {
    return {
      within: `${values.radius}${values.unit.value}@${values.latlon}`
    }
  },
  query: values => {
    return {
      q: values.query
    }
  },
  topForm: values => {
    return {
      limit: values.limit,
      getAllPages: values.getAllPages
    }
  }
}

export const formatFilters = (filters) => {
  let params = {
    offset: 0
  }
  if (!R.isEmpty(filters)) {
    params = filters.reduce((params, filter) => {
      return R.merge(params, FormatterMap[filter.type](filter.values))
    }, {})
  }
  return params
}
